import { BusinessDestinationInfo, CustomerDestinationInfo, DestinationInfoType, MaritimeDestinationInfo } from "./DestinationInfo";

// TODO: 置き場とファイルの内容整理
// 判別用 Type Guard: MaritimeDestinationInfo かどうか
export function isMaritimeDestinationInfo(value: any): value is MaritimeDestinationInfo {
  return !!value && typeof value === "object" && (
    value.type === "MaritimeDestinationInfo"
    || value.type === DestinationInfoType?.MaritimeDestinationInfo
  )
};

// 判別用 Type Guard: BusinessDestinationInfo かどうか
export function isBusinessDestinationInfo(value: any): value is BusinessDestinationInfo {
  return !!value && typeof value === "object" && (
    value.type === "BusinessDestinationInfo"
    || value.type === DestinationInfoType?.BusinessDestinationInfo
  )
};

// 判別用 Type Guard: CustomerDestinationInfo かどうか
export function isCustomerDestinationInfo(value: any): value is CustomerDestinationInfo {
  return !!value && typeof value === "object" && (
    value.type === "CustomerDestinationInfo"
    || value.type === DestinationInfoType?.CustomerDestinationInfo
  );
};

// アサーション関数
export function assertMaritimeDestination(value: any): asserts value is MaritimeDestinationInfo {
  if (!isMaritimeDestinationInfo(value)) {
    throw new Error("Value is not MaritimeDestinationInfo");
  };
};

export function assertBusinessDestination(value: any): asserts value is BusinessDestinationInfo {
  if (!isBusinessDestinationInfo(value)) {
    throw new Error("Value is not BusinessDestinationInfo");
  };
};

export function assertCustomerDestination(value: any): asserts value is CustomerDestinationInfo {
  if (!isCustomerDestinationInfo(value)) {
    throw new Error("Value is not CustomerDestinationInfo");
  };
};